const colors = {
  // primary: '#029636',
  // primary: 'rgba(41, 45, 50, 1)',
  primary: 'rgba(247, 181, 0)',
  white: '#FFFFFF',
  black: '#000000',
  focusBg: 'rgba(247, 181, 0,1)',

  bg: '#F5F5F5',
  navbarScreenHeading: '#303972',

  carCardPlateBg: '#CB0003',
  greenLight: '#0DB21466',
  btnPrimary: '#029636',
  btnSecondry: '#fff',
  btnSecondryBorder: '#029636',

  // primaryLight: 'rgba(2,150,42,0.2)',
  primaryLight: 'rgba(247, 181, 0,1)',

  textBlack: '#000',
  textWhite: '#fff',
  textPrimary: '#000000',
  textWhite: '#fff',
  greenText: '#006A04',
  dimText: '#666666',
  focusText: '#000000',

  text: '#303972',
  danger: '#d9534f',

  sidebar: '#FFFFFF'




};

export default colors;
